<app-header class="request-banner" bannerImage="sprayer-sky.webp"></app-header>
<h1 i18n="@@TankmixRequestForm">Tankmix Request Form</h1>


<form [formGroup]="tankmixRequestForm" class="form-yara" autocomplete="on" >

  <div class="sideBySide">
    <div>
      <div class="form-group">
        <label for="nameTextBox" i18n="@@Name">Name</label>
        <input type="text" id="nameTextBox" name="name" formControlName="name" autocomplete="on" />
        <div *ngIf="name.errors?.['required'] && name.touched" class="text-danger" i18n="@@Required">
          Required
        </div>
        <small class="form-text textmuted"></small>
      </div>
      <div class="form-group">
        <label for="emailTextBox" i18n="@@Email" autocomplete="email">Email</label>
        <input type="email" id="emailTextBox" autocomplete="on" formControlName="email" />
        <div *ngIf="email.errors?.['required'] && email.touched" class="text-danger" i18n="@@Required">
          *
        </div>
        <div *ngIf="email.errors?.['email'] && email.touched" class="text-danger">
          *
        </div>
        <small class="form-text textmuted"></small>
      </div>
      <div class="form-group">
        <label for="companyTextBox" i18n="@@Company">Company</label>
        <input type="text" id="companyTextBox" name="companyTextBox" formControlName="company" />
        <small class="form-text textmuted"></small>
      </div>
    </div>

    <div>
      <div class="form-group">
        <label for="requestDateTextBox" i18n="@@RequestDate">Request Date</label>
        <input type="date" id="requestDateTextBox" name="requestDateTextBox" formControlName="requestDate" />

        <div *ngIf="requestDate.errors?.['required'] && requestDate.touched" class="text-danger" i18n="@@Required">
          Required
        </div>
        <small class="form-text textmuted"></small>
      </div>
      <div class="form-group">
        <label for="countryDropDown" i18n="@@Country">Country</label>
        <div class="form-group">
          <select id="countryDropDown" required name="countryDropDown" formControlName="countryCode"
                  autocomplete="country-name" (change)="changeCountry()">
            <option *ngFor="let choice of countryChoices" [value]="choice.id">
              {{ choice.name }}
            </option>
          </select>
          <small *ngIf="!countryChosen" class="form-text textmuted error" i18n="@@Required">Required</small>
        </div>

        <small *ngIf="countryChosen" class="form-text textmuted"> </small>
      </div>
      <div class="form-group">
        <label for="cropTextBox" i18n="@@Crop">Crop</label>
        <input type="text" id="companyTextBox" name="cropTextBox" formControlName="crop" />
        <small class="form-text textmuted"></small>
      </div>
    </div>
  </div>

  <div class="form-group">
    <label for="commentsTextArea" i18n="@@Comments">Comments</label>
    <textarea type="text" id="commentsTextArea" name="commentsTextArea" formControlName="comments" rows="3"></textarea>
    <small class="form-text textmuted"></small>
  </div>

  <div class="alert alert-warning">
    <div class="header">
      <strong i18n="@@idealMixingOrder">General Guidance of Mixing Order</strong>
    </div>
    <ol>
      <li i18n="@@WaterConditioners">Water Conditioners or anti-foam (if needed)</li>
      <li i18n="@@SolidMicronutrients">Solid Micronutrients</li>
      <li i18n="@@SolidCropProtectionProducts">Solid crop protection products (eg wettable granules, solid granules,
        wettable powder)</li>
      <li i18n="@@WaterBasedCropProtectionProducts">Water based crop protection products (eg suspension concentrates,
        capsule suspensions)</li>
      <li i18n="@@SuspensionConcentrates">Suspension concentrates / liquid micronutrients</li>
      <li i18n="@@SolventBasedCropProtectionProducts">Solvent based crop protection products (eg suspo emulsions,
        emulsion in water, oil dispersal, emulsion concentrates)</li>
      <li i18n="@@Adjuvants">Adjuvants (if needed)</li>
    </ol>
  </div>

  <div class="request-ingredient-table">
    <div class="header">
      <span i18n="@@OrderAddition">Order of Addition</span>
      <span i18n="@@ProductAgro">YaraVita Product or agrochemical</span>
      <span i18n="@@ApplicationRate">Application Rate</span>
      <span i18n="@@Units">Units</span>
      <span></span>
    </div>
    <ng-container formArrayName="ingredients">
      <ng-container *ngFor="let ingredientForm of ingredients.controls; let i = index">
        <div class="hideIfThin ingredientRow" [formGroup]="ingredientForm">
          <span class="order-of-addition">{{ i + 1 }}</span>
          <span>
            <input
            type="text"
            name="ingredientname"
             formControlName="name" placeholder="YaraVita Product or agrochemical"
             i18n-placeholder="@@ProductAgro"
          /> 
        


                             
          </span>
           <span>
            <input type="number" name="applicationRate" formControlName="applicationRate" min="0"
                    />
          </span>
          <span>
            <select name="applicationUnit" formControlName="applicationUnit">
              <option value=""></option>
              <option *ngFor="let choice of applicationUnitChoices"
                      [selected]="choice==ingredientForm.value.applicationUnit">
                {{choice}}
              </option>
            </select>
          </span>
          <span>
            <button [hidden]="i <= 1" class="btn-danger" (click)="deleteProduct(i)">
              Delete
            </button>
          </span>
        </div>
        <div class="showIfThin ingredientRow" [formGroup]="ingredientForm">
          <h5  i18n="@@OrderAddition">Order of Addition {{i+1}}</h5>
          
          <span i18n="@@ProductAgro">YaraVita Product or agrochemical</span>
          <span>
             <input
            type="text"
            name="ingredientname"
             formControlName="name" placeholder="YaraVita Product or agrochemical"
             i18n-placeholder="@@ProductAgro"
          /> 
          <!--            <app-nameid-typeahead [items]="yaraProductChoices" id="yaraProductCode" formControlName="name"
                                  class="form-control"></app-nameid-typeahead>
          -->
          </span>
          <span  i18n="@@ApplicationRate">Application Rate</span>
          <span>
            <input type="number" name="applicationRate" formControlName="applicationRate" min="0"
                   />
          </span>
          <span>
            <select name="applicationUnit" formControlName="applicationUnit">
              <option value=""></option>
              <option *ngFor="let choice of applicationUnitChoices"
                      [selected]="choice==ingredientForm.value.applicationUnit">
                {{choice}}
              </option>
            </select>
          </span>
          <span>
            <button [hidden]="i <= 1" class="btn-danger" (click)="deleteProduct(i)">
              Delete
            </button>
          </span>
         
        </div>
      </ng-container>
    </ng-container>

    <div class="ingredientRow">
      <span class="water-wate" for="waterRateTextBox" i18n="@@WaterRate">Water Rate</span>
      <span></span>
      <span><input class="water-rate-textbox" type="number" id="waterRateTextBox" name="waterRateTextBox"
               formControlName="waterRate" min="0" />
      </span>
      <span>
        <select class="water-rate-units" id="waterRateUnits" required name="waterRateUnits"
                formControlName="waterRateUnits">
          <option [value]="" [ngValue]="null" disabled>
            --Select Water Unit Rate--
          </option>
          <option *ngFor="let choice of waterRateChoices" [value]="choice.id">
            {{ choice.name }}
          </option>
        </select>
      </span>

      <span></span>
    </div>
  </div>

  <div *ngIf="waterRate.errors?.['required'] && waterRate.touched" class="text-danger" i18n="@@Required">
    Required
  </div>
  <div *ngIf="waterRate.errors?.['min'] && waterRate.touched" class="text-danger">
    Water Rate cannot be negative
  </div>

  <button id="addIngredient" class="btn" (click)="addProduct()" i18n="@@AddIngredient">
    Add Ingredient
  </button>

</form>
<div class="alert alert-warning">

  <p>
    <strong i18n="@@Reasonable">Reasonable Request:</strong>
  </p>
  <p i18n="@@ReasonableNote">
    We do not charge any fees for the Tankmix laboratory analysis. The service
    is free of charge. We expect that at least one YaraVita product is included in
    the mix; if no YaraVita product is included, your request may be rejected.
  </p>
</div>
<div class="alert alert-warning">
  <p>
    <strong i18n="@@ImportantNote">IMPORTANT NOTE:</strong>
  </p>
  <p i18n="@@NoteRequestForm">
    Tank mixes are made for convenience of application only.
    The test results provided do not represent a guarantee of chemical and/or biological compatibility,
    nor crop safety of any tank mix. The test conducted and the conclusions drawn do not represent or imply an approval
    or
    recommendation by Yara for application of the mixture to any agricultural crop.
    It should be noted that agrochemicals based on the same active ingredient may vary in
    concentration and formulation. This can affect the tank mixability. Active ingredient alone is no
    guarantee of the product's tank mix properties and therefore a result for an active ingredient
    should not be considered as a result for tank mixing other than for the specific product named
    with the specified country of origin. For further information on all aspects of tank mixing of Yara's
    nutritional products with other agrochemical products or compounds visit the www.tankmix.com.
    Yara does not recommend the mixing of its products with any other product or compound not included
    on the Tankmix™ database. This information is correct at the time of printing and replaces all
    previous information relating to tank mixing. We reserve the right to update information
    regularly without prior notification.
  </p>
</div>

<app-empty-ingredient *ngIf="invalidIngredients"></app-empty-ingredient>
<button [hidden]="!tankmixRequestForm.valid" id="submit" class="btn-success" (click)="submitRequest()" i18n="@@Submit"
        [disabled]="tankmixRequestForm.invalid">
  Submit
</button>

<p>
  <strong i18n="@@RequestFormFooterNote">Please ensure that application rates and water rates are included with your
    request. Read the notes at the bottom of page before acting on tank mix test
    results.</strong>
</p>
<div id="formedEmail" class="never-displayed">
  <h1>Details</h1>
  <table>
    <tr>
      <th i18n="@@Name">Name</th>
      <td>{{ formValues.name }}</td>
    </tr>
    <tr>
      <th i18n="@@Email">Email</th>
      <td>{{ formValues.email }}</td>
    </tr>
    <tr>
      <th i18n="@@Company">Company</th>
      <td>{{ formValues.company }}</td>
    </tr>
    <tr>
      <th >Category of Tankmix</th>
      <td>{{ formValues.kind }}</td>
    </tr>
    <tr>
      <th i18n="@@Crop">Crop</th>
      <td>{{ formValues.crop }}</td>
    </tr>
    <tr>
      <th i18n="@@RequestDate">Request Date</th>
      <td>{{ formValues.requestDate }}</td>
    </tr>
    <tr>
      <th i18n="@@Country">Country</th>
      <td>{{ formValues.countryCode }}</td>
    </tr>
    <tr>
      <th i18n="@@WaterRate">Water Rate</th>
      <td>{{ formValues.waterRate }}</td>
    </tr>
    <tr>
      <th i18n="@@WaterRateUnits">Water RateUnits</th>
      <td>{{ formValues.waterRateUnits }}</td>
    </tr>
    <tr>
      <th i18n="@@Comments">Comments</th>
      <td>{{ formValues.comments }}</td>
    </tr>
    <tr></tr>
  </table>

  <h2 i18n="@@Composition">Composition</h2>

  <table class="">
    <thead></thead>
    <tr>
      <th i18n="@@OrderAddition">Order of Addition</th>
      <th i18n="@@ProductAgro">YaraVita Product or agrochemical</th>
      <th i18n="@@ApplicationRate">Application Rate</th>
      <th i18n="@@Units">Units</th>
    </tr>
    <tbody>
      <ng-container *ngFor="let ingredient of formValues.ingredients; let i = index">
        <tr>
          <td>{{ i + 1 }}</td>
          <td>{{ ingredient.name }}</td>

          <td>{{ ingredient.applicationRate }}</td>
          <td>{{ ingredient.applicationUnit }}</td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>